
import useLayers from "./useLayers.js";
import { Navbar2 } from "../../Components/Navbar2/Navbar2.js";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import MapView from '../../Components/MapGL copy.jsx'


export default function Layers() {

useLayers()
  return (
 <>
<div className="w-full px-3 md:px-5 md:pl-6 py-5 md:py-4 overflow-x-hidden ">
    {/* <div className=' bg-white px-10 h-screen w-screen pb-20 pt-10 lg:px-44 flex flex-col justify-center items-center '>
   <WeatherMap/>
      </div> */}
    {/* <div
          style={{ background: 'linear-gradient(135deg,rgb(24, 32, 47) 0%, #2E428A 50%,rgb(24, 32, 47) 100%)' }}

     className=' bg-gradient-to-r from-indigo-900 to-gray-900 px-10 min-h-screen w-screen pb-28 pt-28 lg:px-44 flex flex-col justify-center items-center '>
     
      </div> */}
   <div className="w-full">
     <MapView />
   </div>

</div>
<SimpleFooter/>
      </>
  );
}
